import script from "./ds-promo-banner-new.vue?vue&type=script&setup=true&lang=ts"
export * from "./ds-promo-banner-new.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__